import BENEFITS from './benefits.services';
import SCORES from './scores.services';
import SCORE_REQUESTS from './scoreRequests.services';
import BENEFIT_APPLICATIONS from './benefitApplications.services';
import QR_VERIFICATION from './qrVerification.services';

const SERVICES = {
	BENEFITS,
	SCORES,
	SCORE_REQUESTS,
	BENEFIT_APPLICATIONS,
	QR_VERIFICATION
};

export default SERVICES;
